<section class="container-03">
  <div class="p-default" [ngClass]="cueElement.theme">
    <div *ngFor="let e of cueElement.elements; trackBy: trackByFnc" [ngClass]="'highlight-type-' + e.type">
      <sdx-cue-content-portal  [content]="e"></sdx-cue-content-portal>
    </div>
  </div>
</section>
